import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import toggleSideNav from 'modules/_shared/redux/sideNavActions';

type Props = {
  linkTo: string;
  text: string;
  disabled?: boolean;
};

const MenuItem: FC<Props> = ({ linkTo, text, disabled = false }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  return (
    <li className={`nk-menu-item ${disabled ? 'disabled' : ''}`}>
      {disabled ? (
        <Link
          to="#"
          className="nk-menu-link text-soft"
          style={{ cursor: 'not-allowed', opacity: 0.5 }}
          title={t(text)}
        >
          <span className="nk-menu-text">{t(text)}</span>
        </Link>
      ) : (
        <Link
          to={linkTo}
          className="nk-menu-link"
          onClick={() => dispatch(toggleSideNav())}
          title={t(text)}
        >
          <span className="nk-menu-text">{t(text)}</span>
        </Link>
      )}
    </li>
  );
};

export default MenuItem;
